import * as React from 'react';
import { forceCheck } from 'react-lazyload';
import { SimpleLazyLoadWrapper } from './simple-lazy-load-wrapper';
/**
 * only use this if we are lazy loading the component and the
 * scroll container isn't **<body>** such as split-view since there is a bug in react-lazy
 * library https://github.com/twobin/react-lazyload/issues/371.
 */
export const ScrolledLazyLoadWrapper = props => {
  const [lazyLoadRef, setLazyLoadRef] = React.useState(null);
  React.useEffect(() => {
    if (!(lazyLoadRef === null || lazyLoadRef === void 0 ? void 0 : lazyLoadRef.ref)) return;
    const lazyLoadContainer = lazyLoadRef.ref;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          forceCheck();
        }
      });
    }, {
      rootMargin: '-200px'
    });
    observer.observe(lazyLoadContainer);
    return () => observer.unobserve(lazyLoadContainer);
  }, [lazyLoadRef]);
  return React.createElement(SimpleLazyLoadWrapper, Object.assign({
    ref: ref => {
      // force re-render the component for the intersectionObservable to run
      setLazyLoadRef(ref);
      return ref;
    }
  }, props));
};